(function() {
    function initOverride(embed) {
        if (!embed) return;

        // 1. GHI ĐÈ HÀM UPDATE ĐỂ PHẢN HỒI REAL-TIME KHI THÊM/XÓA SẢN PHẨM
        const originalUpdateAllCartGoals = embed.updateAllCartGoals;
        embed.updateAllCartGoals = function() {
            try {
                if (typeof this.renderAllCartGoals === 'function') {
                    this.renderAllCartGoals();
                } else if (typeof originalUpdateAllCartGoals === 'function') {
                    originalUpdateAllCartGoals.call(this);
                }
            } catch (e) {
                if (typeof originalUpdateAllCartGoals === 'function') {
                    try { originalUpdateAllCartGoals.call(this); } catch (_) {}
                }
            }
        };

        // 2. GHI ĐÈ LOGIC KIỂM TRA HIỂN THỊ WIDGET
        const originalGetWidgetVisibility = embed.getWidgetVisibility;
        if (originalGetWidgetVisibility) {
            embed.getWidgetVisibility = function(showConfigString) {
                try {
                    const visibility = originalGetWidgetVisibility.call(this, showConfigString);
                    if (!visibility) return visibility;

                    // Kiểm tra riêng biệt cho từng giao diện hiển thị
                    const cartHasTrigger = checkCartHasTrigger(this);
                    const pageProductMatches = checkPageProductMatches(this);

                    return {
                        cartDrawer: !!(visibility.cartDrawer && cartHasTrigger),
                        cartPage: !!(visibility.cartPage && cartHasTrigger),
                        productPage: !!(visibility.productPage && pageProductMatches),
                    };
                } catch (e) {
                    // Dự phòng: Trả về logic gốc nếu override bị lỗi để không làm hỏng tính năng mặc định
                    try {
                        return originalGetWidgetVisibility.call(this, showConfigString);
                    } catch (_) {
                        return { cartDrawer: false, cartPage: false, productPage: false };
                    }
                }
            };
        }
    }

    // Tự động gọi API lấy Collection của Product Page khi chưa có
    function fetchProductCollections(embed, productId, variantId) {
        if (!embed) return;
        if (!embed._fetchingProductIds) {
            embed._fetchingProductIds = new Set();
        }
        if (embed._fetchingProductIds.has(productId)) return;
        embed._fetchingProductIds.add(productId);

        const checkAndFetch = () => {
            try {
                const tokenKey = embed.STORE_ACCESS_TOKEN_KEY;
                const token = tokenKey ? localStorage.getItem(tokenKey) : null;
                
                if (token && typeof embed.getVariantData === 'function') {
                    embed.getVariantData(variantId).then(() => {
                        if (typeof embed.renderAllCartGoals === 'function') {
                            embed.renderAllCartGoals();
                        }
                    }).catch(err => {
                        embed._fetchingProductIds.delete(productId);
                    });
                } else {
                    // Thử lại sau 100ms nếu token chưa load xong
                    setTimeout(checkAndFetch, 100);
                }
            } catch (e) {
                embed._fetchingProductIds.delete(productId);
            }
        };
        checkAndFetch();
    }

    // Kiểm tra xem giỏ hàng có sản phẩm thỏa mãn Rule hay không
    function checkCartHasTrigger(embed) {
        try {
            const cartGoal = embed?.cartGoal;
            if (!cartGoal || Object.keys(cartGoal).length === 0) return false;

            const triggerCondition = cartGoal.trigger_condition;
            if (triggerCondition === "all") return true;

            let triggerConditionIds = [];
            try {
                triggerConditionIds = JSON.parse(cartGoal.trigger_condition_ids || "[]").map(a => String(a.shopify_id));
            } catch (e) {
                return false;
            }

            const cartItems = embed.cartItems || [];

            if (triggerCondition === "product") {
                return cartItems.some(item => {
                    return !embed.checkIsGift(item) && 
                           triggerConditionIds.includes(String(item.product_id)) && 
                           embed.checkPurchaseType(item);
                });
            } else if (triggerCondition === "collection") {
                const setCollectionIds = new Set(triggerConditionIds);
                return cartItems.some(item => {
                    if (embed.checkIsGift(item) || !embed.checkPurchaseType(item)) return false;
                    const productId = String(item.product_id);
                    const collections = embed.productIdMapCollection?.get(productId) || [];
                    return collections.map(String).some(colId => setCollectionIds.has(colId));
                });
            }
        } catch (e) {}
        return false;
    }

    // Kiểm tra xem sản phẩm đang hiển thị ở Product Page có thỏa mãn Rule hay không
    function checkPageProductMatches(embed) {
        try {
            const cartGoal = embed?.cartGoal;
            if (!cartGoal || Object.keys(cartGoal).length === 0) return false;

            const triggerCondition = cartGoal.trigger_condition;
            if (triggerCondition === "all") return true;

            let triggerConditionIds = [];
            try {
                triggerConditionIds = JSON.parse(cartGoal.trigger_condition_ids || "[]").map(a => String(a.shopify_id));
            } catch (e) {
                return false;
            }

            let currentProductId = window.tlCurrentProductId || window.ShopifyAnalytics?.meta?.product?.id || window.meta?.product?.id;
            currentProductId = currentProductId ? String(currentProductId) : null;

            if (!currentProductId) return false;

            if (triggerCondition === "product") {
                return triggerConditionIds.includes(currentProductId);
            } else if (triggerCondition === "collection") {
                const setCollectionIds = new Set(triggerConditionIds);
                let collections = embed.productIdMapCollection?.get(currentProductId);

                // Nếu chưa có thông tin collection, tiến hành lấy variant ID để fetch
                if (!collections) {
                    let variantId = new URLSearchParams(window.location.search).get('variant');
                    if (!variantId && window.meta?.product?.variants?.length) {
                        variantId = window.meta.product.variants[0].id;
                    }
                    if (!variantId && window.ShopifyAnalytics?.meta?.selectedVariantId) {
                        variantId = window.ShopifyAnalytics.meta.selectedVariantId;
                    }
                    // Tìm kiếm trực tiếp trên DOM của trang sản phẩm nếu các biến window không khả dụng
                    if (!variantId) {
                        const idInput = document.querySelector('form[action*="/cart/add"] [name="id"], select[name="id"], input[name="id"]');
                        if (idInput) {
                            variantId = idInput.value;
                        }
                    }
                    
                    if (variantId) {
                        fetchProductCollections(embed, currentProductId, variantId);
                    }
                    collections = window.tlCurrentProductCollections || [];
                }

                return collections.map(String).some(colId => setCollectionIds.has(colId));
            }
        } catch (e) {}
        return false;
    }

    // Đăng ký Listener lắng nghe thực thi an toàn
    try {
        if (window.tlCartGoalEmbed) {
            initOverride(window.tlCartGoalEmbed);
        } else {
            let embedInstance = null;
            Object.defineProperty(window, 'tlCartGoalEmbed', {
                configurable: true,
                enumerable: true,
                get() {
                    return embedInstance;
                },
                set(val) {
                    embedInstance = val;
                    if (val) {
                        initOverride(val);
                    }
                }
            });
        }
    } catch (e) {}
})();
